import type { Pixel } from '@entities/product/api/product.contract'

export function newProductPixel(provider: Pixel['provider'], id: string): Pixel {
  if (provider === 'facebook' || provider === 'tiktok') {
    return {
      id,
      provider,
      pixelId: '',
      accessToken: '',
      sendOnlyCommission: true,
      sendOnlyCommissionLocked: false,
    }
  }
  if (provider === 'google_ads') {
    return {
      id,
      provider,
      pixelId: '',
      conversionLabel: '',
      conversionEvent: 'purchase',
      sendOnlyCommission: true,
      sendOnlyCommissionLocked: false,
    }
  }
  return {
    id,
    provider,
    accessToken: '',
    sendOnlyCommission: true,
    sendOnlyCommissionLocked: false,
  }
}
